import React from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

function Autoplay({ delay, stopOnHover }) {
  return (slider) => {
    let timeout;
    let mouseOver = false;

    const clearNextTimeout = () => clearTimeout(timeout);
    const nextTimeout = () => {
      clearTimeout(timeout);
      if (mouseOver && stopOnHover) return;
      timeout = setTimeout(() => slider.next(), delay);
    };

    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true;
        clearNextTimeout();
      });
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false;
        nextTimeout();
      });
      nextTimeout();
    });

    slider.on("dragStarted", clearNextTimeout);
    slider.on("animationEnded", nextTimeout);
    slider.on("updated", nextTimeout);
  };
}

export default function RoomCarousel({ images, onImageClick }) {
  const sliderOptions = {
    loop: true,
    rubberband: true,
    drag: true,
    mode: "snap",
    slides: { perView: 1.2, spacing: 16 },
    breakpoints: {
      "(min-width: 640px)": { slides: { perView: 2, spacing: 20 } },
      "(min-width: 1024px)": { slides: { perView: 3, spacing: 24 } },
    }
  };

  const [sliderRef] = useKeenSlider(sliderOptions, [
    Autoplay({ delay: 2000, stopOnHover: true }),
  ]);

  return (
    <div ref={sliderRef} className="keen-slider">
      {images.map((img, i) => (
        <div
          key={i}
          className="keen-slider__slide relative rounded-xl overflow-hidden shadow-lg cursor-pointer group"
          onClick={() => onImageClick(img)}
        >
          <img
            src={img}
            alt={`Room ${i + 1}`}
            loading="eager"
            className="w-full h-56 sm:h-64 lg:h-72 object-cover transform transition-transform duration-300 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-300"></div>
          <div className="absolute bottom-2 right-2 bg-white text-black text-xs sm:text-sm font-semibold px-2 py-1 rounded shadow opacity-0 group-hover:opacity-100 transition duration-300">
            Click Me
          </div>
        </div>
      ))}
    </div>
  );
}
